import React, {useContext, useEffect, useRef, useState} from "react";
import {Avatar, Button, Card, Col, Divider, Form, Input, message, Modal, Row, Space, Tag,Typography} from "antd";
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";
import axios from "../../api/axios";
import NumberInputBM from "../../components/NumberInput";
import EmpCertAdd from "../../pages/Employee/EmpCertAdd";
import styled from "styled-components";
import {
    BankOutlined,
    CameraOutlined, EditOutlined,
    IdcardOutlined, KeyOutlined,
    LockOutlined,
    PhoneOutlined,
} from "@ant-design/icons";
import DidoxUsersTab from "../../pages/Document/Didox/DidoxUser/DidoxUsersTab";

const {Text} = Typography;
const QUERY_URL = '/api/public/query';
const SAVE_URL = '/user/changePassword';

const UserForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 10px;
  }
`;



const UserProfile = ({empId}) => {

    const navigate = useNavigate();

    const auth = useContext(AuthContext);
    const [form] = Form.useForm()
    const [formPassword] = Form.useForm()
    const [messageApi, contextHolder] = message.useMessage();
    const filialInnRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState({initial: '', fio: '', id:'', phoneNumber: '', mobileNumber: '', pinfl: '', struct:'', staff: ''});
    const [showDidox, setShowDidox] = useState(false);

    const headers = {
        'Content-Type':'application/json;charset=utf-8',
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Credentials':'true',
        'Authorization':`Bearer ${auth.token}`,
        'withCredentials': true
    }

    const onFinish = async (values) => {

        const userLogin = form.getFieldValue("login");
        const userPass = values.passwordNew;

        try {
            const data = await axios.post(SAVE_URL,

                JSON.stringify({'login':userLogin, 'password':userPass})
                , {
                    headers: headers
                }
                // )
            ).then(response => {

                console.log(response, 'response')
                if (response.status === 200) {
                    message.success('Парол узгартирилди', navigate('/'));

                }

            })
            //message.success('Парол узгартирилди', handleFormExit);


        } catch (err) {
            message.error(err.response?.data?.message);
        }
    }

    const dataTab = {
        "query": {
            "id": "USERS_UI_V",
            "source": "USERS_UI_V",
            "fields": [
                {   "column": "id",  },
                {   "column": "filial",  },
                {   "column": "filial_name",  },
                {   "column": "fio",  },
                {   "column": "login",  },
                {   "column": "phonenumber",  },
                {   "column": "mobilenumber",  },
                {   "column": "staff",  },
                {   "column": "struct",  },
                {   "column": "pinfl",  },
                {   "column": "staff_name",  },
                {   "column": "state",  },
                {   "column": "state_name",  },
                {   "column": "created_by",  },
                {   "column": "created_by_name",  },
                {   "column": "created_date",  },
                {   "column": "modified_by",  },
                {   "column": "modified_by_name",  },
                {   "column": "modified_date",  }
            ]
        }
    }

    const getTabData = async () => {

        dataTab.query['filters'] = [{"column": "id", "value": empId, "operator": "=", "dataType": "number"}];

        const { data } = await axios.post(QUERY_URL,
            ( dataTab ),
            {
                headers: headers,
                //crossDomain: true,
                withCredentials: false
            });

        setLoading(false);
        console.log(data)
        //form.setFieldValue("fio",data[0].fio)
        form.setFieldsValue({
            "fio":data[0].fio,
            "filial":data[0].filial + ' - ' + data[0].filial_name,
            "login":data[0].login,
            "phonenumber":data[0].phonenumber,
            "mobilenumber":data[0].mobilenumber,
            "state":data[0].state_name,
            "pinfl":data[0].pinfl,

        })
        const obj = data[0];

        setUserData({ ...userData,
            initial: obj.fio.split(" ")[0].substr(0, 1) + obj.fio.split(" ")[1].substr(0, 1),
            fio: obj.fio,
            id: obj.id,
            phoneNumber: obj.phonenumber,
            mobileNumber: obj.mobilenumber,
            struct: obj.struct_name,
            staff: obj.staff_name,
            state: obj.state_name

        })



    };

    useEffect(() => {
        getTabData();
    }, []);

    const handleFormSubmit = () => {

        formPassword
            .validateFields()
            .then(async (values) => {
                console.log(JSON.stringify(values),'eeed')
                return
                try {
                    const data = await axios.post(SAVE_URL,

                        JSON.stringify(values)
                        , {
                            headers: headers
                        }
                        // )
                    ).then(response => { console.log(response, 'response')} )
                    //message.success('Парол узгартирилди', handleFormExit);
                    messageApi.open({
                        type: 'success',
                        content: 'Парол узгартирилди',
                        duration: 2,
                    }).then(()=> null);

                } catch (err) {
                    message.error(err.response?.data?.message);
                }

            })
            .catch((errorInfo) => {
                console.log('errorInfo ...', errorInfo);
            }).then(r => r);
    }

    const formItemLayout =
        {
            labelCol: {
                span: 8,
            },
            wrapperCol: {
                span: 16,
            },
        }

    const handleFormExit = () => {
        navigate(-1)
    }

    const S = {
        sectionLabel: {
            fontSize: 10,
            fontWeight: 700,
            color: "#4f72ff",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 20,
        },
        sectionBar: {
            display: "block",
            width: 3,
            height: 13,
            background: "#4f72ff",
            borderRadius: 2,
        },
    }




    const handleOpenDidox = async () => {
        if (!filialInnRef.current) {
            const res = await axios.get('/auth/user/getCurrentUserFilialInn', { headers });
            filialInnRef.current = res.data;
        }
        setShowDidox(true);
    };

    return (
        <>
            {contextHolder}
            <Space direction="horizontal" size="middle" style={{ display: "flex", justifyContent:"center", alignItems: "center", height: "100%", width: "100%", position: "relative", overflow: "hidden" }}/>

            <Card style={{

                //border: "1px solid #1e2337",
                borderRadius: 18,
            }} styles={{body: {padding: 28}}}>

                <Row gutter={18} align="middle" style={{marginBottom: 24}}>
                    <Col>
                        <div style={{position: "relative", display: "inline-block"}}>
                            <Avatar size={68} style={{
                                background: "linear-gradient(135deg, #4f72ff, #7c3aed)",
                                fontSize: 22,
                                fontWeight: 700,
                                cursor: "pointer",
                                position: "relative",
                                overflow: "hidden",
                            }}>
                                {userData.initial}
                            </Avatar>
                            <div style={{
                                position: "absolute", inset: 0, borderRadius: "50%",
                                background: "rgba(79,114,255,0.72)", display: "flex",
                                alignItems: "center", justifyContent: "center", opacity: 0,
                                transition: "0.2s", cursor: "pointer",
                            }}
                                 onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                                 onMouseLeave={(e) => (e.currentTarget.style.opacity = "0")}
                            >
                                <CameraOutlined style={{color: "#fff", fontSize: 20}}/>
                            </div>
                        </div>
                    </Col>
                    <Col flex="1">
                        <Text style={{fontSize: 17, fontWeight: 700, display: "block"}}>
                            {userData.fio}
                        </Text>
                        <Space size={7} style={{marginTop: 7}}>
                            <Tag color="blue" style={{borderRadius: 6, fontSize: 10.5, fontWeight: 600}}>
                                {userData.staff}
                            </Tag>
                            <Tag color="green" style={{borderRadius: 6, fontSize: 10.5, fontWeight: 600}}>
                                {userData.state}
                            </Tag>
                        </Space>
                        <Text style={{display: "block", color: "#555e7a", fontSize: 11, marginTop: 5}}>
                            ID:{" "}
                            <span style={{fontFamily: "'JetBrains Mono', monospace", color: "#4f72ff"}}>
                    {userData.id}
                  </span>{" "}
                            {/* · Последний вход: 30 апр, 2026, 09:14*/}
                        </Text>
                    </Col>
                </Row>

                <Divider style={{ margin: "0 0 22px"}}/>

                <div style={S.sectionLabel}>
                    <span style={S.sectionBar}/>
                    Личные данные
                </div>

                <Form form={form} layout="vertical">

                    <Row gutter={18}>
                        <Col xs={24} sm={12}>
                            <Form.Item name="filial" label="Организация">
                                <Input prefix={<BankOutlined/>} placeholder="Организация" readOnly={true}/>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12}>
                            <Form.Item name="phonenumber" label="Рабочий телефон">
                                <Input prefix={<PhoneOutlined/>} placeholder="+998 XX XXX XX XX" readOnly={true}/>
                            </Form.Item>
                        </Col>

                        <Form.Item name="login" label="login" hidden={true}>
                            <Input placeholder="login" readOnly={true}/>
                        </Form.Item>
                    </Row>

                    <Row gutter={18}>
                        <Col xs={24} sm={12}>
                            <Form.Item name="pinfl" label="ПИНФЛ">
                                <Input
                                    prefix={<IdcardOutlined/>} placeholder="ПИНФЛ"
                                    style={{fontFamily: "'JetBrains Mono', monospace"}}
                                    readOnly={true}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item name="mobilenumber" label="Мобилный телефон"
                                       rules={[{
                                           required: true,
                                           type: "email",
                                           message: "Некорректный Мобилный телефон"
                                       }]}>
                                <Input prefix={<PhoneOutlined/>} placeholder="example@mail.com" readOnly={true}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                <Divider style={{ margin: "4px 0 22px" }} />

                {/* Password change */}
                <div style={S.sectionLabel}>
                    <span style={S.sectionBar} />
                    Паролни узгартириш
                </div>

                <Form form={formPassword} layout="vertical" scrollToFirstError initialValues={{passwordNew:""}} onFinish={onFinish}>

                    <Row gutter={18}>
                        <Col xs={24} sm={12}>
                            <Form.Item name="passwordNew" label="Парол" rules={[{required:true, message: 'Паролни киритинг'}]}>
                                <Input.Password prefix={<LockOutlined />}/>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item name="confirmNew" label="Паролни тасдиклаш" rules={[{required:true, message: 'Тасдиклаш паролини киритинг'},
                                ({getFieldValue}) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('passwordNew') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Пароллар бир бирига тенг эмас'))
                                    }
                                })]}>
                                <Input.Password prefix={<LockOutlined />}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={18}>
                        <Col xs={24} sm={12}>
                            <Button type="primary" htmlType="submit" style={{marginRight:'10px'}} icon={<EditOutlined />}>
                                Парол узгаришини сақлаш
                            </Button>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Button type="default" style={{marginRight:'10px'}} icon={<KeyOutlined />} onClick={() => handleOpenDidox()}>
                                DIDOX паролини узгартириш
                            </Button>
                        </Col>
                    </Row>
                </Form>

            </Card>

            {/*<UserForm name="userProfile" form={form} layout="vertical" scrollToFirstError initialValues={{}} {...formItemLayout}>


                <Space direction="horizontal">
                <Form.Item name="filial" label="Филиал" rules={[{required: false, message:'Филиални киритинг!'}]}>
                    <Input readOnly="readOnly"/>
                </Form.Item>

                <Form.Item name="fio" label="Ф.И.О" rules={[{required: false, message:'Ф.И.О. ни киритинг!'}]}>
                    <Input readOnly="readOnly"/>
                </Form.Item>

                <Form.Item name="phonenumber" label="Телефон ракам" rules={[{required: false, message:'Телефон ракамни киритинг!'}]}>
                    <Input readOnly="readOnly"/>
                </Form.Item>
                </Space>

                <Form.Item name="mobilenumber" label="Мобил ракам" rules={[{required: false, message:'Мобил ракамни киритинг!'}]}>
                    <Input readOnly="readOnly"/>
                </Form.Item>

                <Form.Item name="state" label="Холат" rules={[{required: false, message:'Холатни киритинг!'}]}>
                    <Input readOnly="readOnly"/>
                </Form.Item>

                <Form.Item name="login" label="Логин" rules={[{required: false, message:'Логинни киритинг!'}]}>
                    <Input readOnly="readOnly"/>
                </Form.Item>

            </UserForm>*/}

            {/*<Divider>Паролни узгартириш</Divider>*/}

            {/*<UserForm form={formPassword} scrollToFirstError initialValues={{passwordNew:""}} onFinish={onFinish}
                  {...formItemLayout}
            >

                <Form.Item name="passwordNew" label="Парол" rules={[{required:true, message: 'Паролни киритинг'}]}>
                    <Input.Password/>
                </Form.Item>

                <Form.Item name="confirmNew" label="Паролни тасдиклаш" rules={[{required:true, message: 'Тасдиклаш паролини киритинг'},
                    ({getFieldValue}) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('passwordNew') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('Пароллар бир бирига тенг эмас'))
                        }
                    })]}>
                    <Input.Password/>
                </Form.Item>

                <Form.Item style={{ textAlign: 'right' }} labelCol={{span:0}} wrapperCol={{span: 24}}>
                    <Button type="primary" htmlType="submit" style={{marginRight:'10px'}}>
                        Паролни узгартириш
                    </Button>
                </Form.Item>

            </UserForm>*/}

            <Divider>Электрон рақамли имзони боғлаш</Divider>


            <EmpCertAdd empId={empId}/>

            {showDidox && <DidoxUsersTab filialInn={filialInnRef.current} setShowDidox={setShowDidox}/>}

            {/*<Button
                onClick={handleEcpDialog}
                type="primary"
            >
                ЭРИ боглаш
            </Button>

            <Modal
                title="ЭРИ боглаш"
                open={openEcpDialog}
                //onOk={handleAction}
                //confirmLoading={confirmLoading}
                onCancel={() => setOpenEcpDialog(false)}
            >
                <EmpCertAdd/>
            </Modal>*/}
        </>
    )
}

export default UserProfile;